import constants from './_constants.js';
import subscriptionConfigs from './_subscription-configs.js';

const toPositiveInteger = (value) => {
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? number : null;
};

// Resolves how many guests a single event may hold:
//   1. the event's own `plan.maxGuests` uplift
//   2. the workspace's `plan.maxGuestsPerEvent` override
//   3. the plan tier's `maxGuestsPerEvent` (null = no tier cap)
//   4. the global HARD_LIMIT_FOR_GUESTS_PER_EVENT
// Whatever wins is clamped to the hard limit, so nothing can raise it.
export const getMaxGuestsPerEvent = ({ event, workspace }) => {
  const hardLimit = constants.HARD_LIMIT_FOR_GUESTS_PER_EVENT;
  const eventUplift = toPositiveInteger(event?.plan?.maxGuests);
  const workspaceOverride = toPositiveInteger(workspace?.plan?.maxGuestsPerEvent);
  const tierDefault = toPositiveInteger(subscriptionConfigs[workspace?.plan?.tier]?.maxGuestsPerEvent);

  return Math.min(eventUplift ?? workspaceOverride ?? tierDefault ?? hardLimit, hardLimit);
};
